import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {ReactNode} from "react";
import type React from "react";
import {memo} from "react";

import {useFilterFragments} from "../../hooks/useFilterFragment";
import {useView, type View} from "../../hooks/useView";
import {Box} from "../ui/box";

import ModalBlock from "./ModalBlock";

type Props = {
    isLoading?: boolean;
    useDefaultDivider?: boolean;
    children: ReactNode;
};

const style = tva({
    base: "flex-1 overflow-y-auto bg-background-0",
    variants: {
        isLoading: {
            true: "justify-center items-center"
        },
        view: {
            native: "",
            webMobile: "",
            webDesktop: ""
        } satisfies Record<View, string>
    }
});

const ModalBody: React.FC<Props> = ({children, isLoading, useDefaultDivider = true}) => {
    const view = useView();

    const body = useFilterFragments(children);

    return (
        <Box
            className={style({
                view
            })}
            testID="modal-body"
        >
            {isLoading ? (
                children
            ) : (
                <>
                    {body.map((elem, idx) => (
                        <ModalBlock
                            key={idx}
                            noBorder={idx === body.length - 1}
                            useDefaultDivider={useDefaultDivider}
                        >
                            {elem}
                        </ModalBlock>
                    ))}
                </>
            )}
        </Box>
    );
};

export default memo(ModalBody);
